import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ReportsActions";
import { ImpiantiByModello } from "../generated";
import { InLocalStorage } from "../common/InLocalStorage";

class TopClimaReportStore extends AbstractGetAllStore<ImpiantiByModello> {
    constructor() {
        super(x => x.marca! + x.modello!, new InLocalStorage<ImpiantiByModello>("TopClimaReport"));
        Dispatcher
            .onfunction(Actions.getTopImpiantiClima, result => this.setAll(result))
            ;
    }
    public useAll = () => this.useAllWithAction(() => Actions.getTopImpiantiClima())
}

export default new TopClimaReportStore()
